import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface QualtricsState {
  permissionGroupDrawer_dontSaveDialog_cofirmBtnId?: string;
}

const initialState: QualtricsState = {
  permissionGroupDrawer_dontSaveDialog_cofirmBtnId: undefined,
};

const qualtricsSlice = createSlice({
  name: 'qualtrics',
  initialState,
  reducers: {
    setPermissionGroupDrawerDntSaveDialogConfirmBtnId(
      state,
      action: PayloadAction<string | undefined>
    ) {
      state.permissionGroupDrawer_dontSaveDialog_cofirmBtnId = action.payload;
    },
  },
});

export const {setPermissionGroupDrawerDntSaveDialogConfirmBtnId} =
  qualtricsSlice.actions;
export default qualtricsSlice.reducer;
